import { KCheckbox } from "@kyburz/kdesign-system";
import React from "react";

export interface TableCheckboxProps {
  indeterminate?: boolean;
  checked?: boolean;
  onChange?: (() => void) | ((e: any) => void);
  handleLatestChecked?: (value: number | string) => void;
  row: any;
  isHeader?: boolean;
}

export const TableCheckbox = ({
  indeterminate,
  checked,
  onChange,
  handleLatestChecked,
  row,
  isHeader,
  ...rest
}: TableCheckboxProps) => {
  const handleChange = (e: any): void => {
    if (onChange) {
      onChange(e);
    }
    if (isHeader && handleLatestChecked) {
      handleLatestChecked("all");
    }
    if (!isHeader && handleLatestChecked) {
      const { index } = row;
      handleLatestChecked(index);
    }
  };
  return (
    <KCheckbox
      checked={checked}
      handleChange={(e) => handleChange(e)}
      indeterminate={indeterminate}
      name="table-checkbox"
      {...rest}
    />
  );
};
